import { render, staticRenderFns } from "./GroupFormPageSDD.vue?vue&type=template&id=12eb1cbd&scoped=true&"
import script from "./GroupFormPageSDD.vue?vue&type=script&lang=js&"
export * from "./GroupFormPageSDD.vue?vue&type=script&lang=js&"
import style0 from "./GroupFormPageSDD.vue?vue&type=style&index=0&id=12eb1cbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb1cbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12eb1cbd')) {
      api.createRecord('12eb1cbd', component.options)
    } else {
      api.reload('12eb1cbd', component.options)
    }
    module.hot.accept("./GroupFormPageSDD.vue?vue&type=template&id=12eb1cbd&scoped=true&", function () {
      api.rerender('12eb1cbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/GroupFormPageSDD.vue"
export default component.exports